<template>
  <div class="container ms-2 me-2 mt-2 border-danger border-bottom border-end p-3">
    <h4>Filtrar según la linea: </h4>
    <div class="form-check mt-2 mb-2">
      <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
        @change="useSheetFilter">
      <label class="form-check-label" for="flexRadioDefault1">
        Láminas
      </label>
    </div>
    <div class="form-check mt-2 mb-2">
      <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
        @change="useProfileFilter">
      <label class="form-check-label" for="flexRadioDefault2">
        Perfiles
      </label>
    </div>
    <div class="form-check mt-2 mb-2">
      <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault3" @change="useTubeFilter">
      <label class="form-check-label" for="flexRadioDefault3">
        Tubos
      </label>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      families: [],
      final_family: "",
    };
  },
  methods: {
    useSheetFilter() {
      this.final_family = "Laminas"
      this.showFamilies(this.final_family);
    },
    useProfileFilter() {
      this.final_family = "Perfiles"
      this.showFamilies(this.final_family);
    },
    useTubeFilter() {
      this.final_family = "Tubos";
      this.showFamilies(this.final_family);
    },
    async showFamilies(family) {
      //console.log(family);
      if (family === "") {
        this.families = [];
      } else {
        try {
          const res = await axios.get(RUTA_SERVIDOR + "api/imgFormFamily/list", {
            params: {
              imgFormFamily_type: family,
            },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          // console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            this.families = res.data;
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
      //Metodo que emite algo al padre en este caso la vista ImageFormFamiliesView
      //Primer parámetro: nombre del evento que el padre recibe
      //Segundo parámetro: lo que le pasa al otro componente
      this.$emit("showFamiliesByFilter", this.families);
    },
  },
};
</script>